module.exports = __webpack_public_path__ + "img/glogo229.e93f883d.png";